import { urlConstants } from 'common/utils/constants';

import { secureApi } from '../api/Axios';

export const getInvestorDetail = () =>
  secureApi.get(urlConstants.getInvestorDetail_url);

export const updateInvestorDetail = (payload: any) =>
  secureApi.post(urlConstants.updateInvestorDetail_url, payload);

export const createUpdateInvestorKyc = (payload: any) =>
  secureApi.post(urlConstants.createUpdateInvestorKyc_url, payload);

export const createInvestmentDetail = (payload: any) =>
  secureApi.post(urlConstants.createInvestmentDetail_url, payload);

export const trackInvestmentProcessDetail = (payload: any) =>
  secureApi.post(urlConstants.getInvestmentTrack_url, payload);

export const getDocuSignUrl = (payload: any) =>
  secureApi.post(urlConstants.getDocuSignDocuments, payload);

export const uploadFileSignedUrl = (payload: any) =>
  secureApi.post(urlConstants.uploadFileSignedUrl, payload);

export const addInvestmentDocument = (payload: any) =>
  secureApi.post(urlConstants.addInvestmentDocument, payload);

export const getInvestmentDocuments = (payload: any) =>
  payload.type
    ? secureApi.get(
        `${urlConstants.getInvestmentDocument}?id=${payload.id}&type=${payload.type}`,
      )
    : secureApi.get(`${urlConstants.getInvestmentDocument}?id=${payload.id}`);

export const getAllInvestmentDocuments = () =>
  secureApi.get(`${urlConstants.getInvestmentDocument}`);

export const getInvestorPayments = (spv?: string) =>
  spv
    ? secureApi.get(`${urlConstants.getInvestorPayments}?spv=${spv}`)
    : secureApi.get(`${urlConstants.getInvestorPayments}`);

export const getInvestorPortfolio = (spv: string) =>
  secureApi.get(`${urlConstants.getInvestorPortfolio}?spv=${spv}`);

export const getInvestorAggregatePortfolio = () =>
  secureApi.get(`${urlConstants.getInvestorAggregatePortfolio}`);

export const getInvestorNavTrack = (spv?: string) =>
  spv
    ? secureApi.get(`${urlConstants.getInvestorNavTrack}?spv=${spv}`)
    : secureApi.get(`${urlConstants.getInvestorNavTrack}`);

export const getKycSSN = (kycId: string) =>
  secureApi.get(`${urlConstants.getKycSSN}?kycId=${kycId}`);

export const getSubscriberSSN = (investmentDetailId: string) =>
  secureApi.get(
    `${urlConstants.getSubscriberSSN}?investmentDetailId=${investmentDetailId}`,
  );

export const getUpcomingDistributions = () =>
  secureApi.get(`${urlConstants.getUpcomingDistributions}`);

export const addRolloverInvestment = (payload: any) =>
  secureApi.post(urlConstants.addRolloverInvestment, payload);

export const addInvestorDocumentByName = (payload: any) =>
  secureApi.post(urlConstants.addInvestorDocumentByName, payload);

export const getInvestorExistingEmails = (payload: any) =>
  secureApi.post(urlConstants.getExistingEmails, payload);

export const getInvestorInvestments = () =>
  secureApi.get(urlConstants.getInvestments);

export const markDocusignSigned = (payload: any) =>
  secureApi.post(urlConstants.markDocusignSigned, payload);
